/* ABC: кнопка мобильного меню.

   У бургера два обработчика сразу: родной у <details> (сам ставит/снимает
   open) и тема через on:click="/toggle" (тоже смотрит на open). Они
   гонялись: второй тап иногда заново открывал меню, у <details> оставался
   open, а вместе с ним блокировка прокрутки темы (html[scroll-lock] и
   overflow:hidden на .page-wrapper). Из-за этого шапка переставала липнуть
   и «пропадала» при прокрутке — баг со скриншота владельца.

   Решение: перехватываем тап раньше обоих и открываем/закрываем сами,
   в одном месте. Анимация — та же, что в CSS (0.3с по классу menu-open);
   блокировку прокрутки тема снимает сама по событию toggle у <details>. */
(function () {
  var DURATION = 300;
  var closing = null;

  function details() { return document.querySelector('#Details-menu-drawer-container'); }

  function open(d) {
    clearTimeout(closing);
    d.open = true;                       // toggle → тема блокирует прокрутку
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { d.classList.add('menu-open'); });
  }

  function close(d) {
    d.classList.remove('menu-open');     // CSS сворачивает панель
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
    clearTimeout(closing);
    closing = setTimeout(function () {
      d.open = false;                    // toggle → тема снимает блокировку
      /* раскрытые подпункты (MEN/WOMEN) сворачиваем к следующему разу */
      d.querySelectorAll('details[open]').forEach(function (x) { x.open = false; });
    }, DURATION);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.header__icon--menu');
    if (!btn) return;
    var d = details();
    if (!d || !d.contains(btn)) return;
    e.preventDefault();                  // родной toggle у <details>
    e.stopImmediatePropagation();        // делегированный on:click темы
    d.classList.contains('menu-open') ? close(d) : open(d);
  }, true);

  /* тап по пункту меню — уходим на страницу, меню закрываем сразу,
     чтобы при возврате «назад» не висела блокировка */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.menu-drawer a[href]');
    if (!link) return;
    var d = details();
    if (d && d.open) close(d);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = details();
    if (d && d.classList.contains('menu-open')) close(d);
  });
})();

/* ABC 25.09: порядок категорий в подменю MEN / WOMEN — «сверху вниз», как одеваются
   (владелец): бомберы, пуховики, худи/свитшоты, лонгсливы, футболки, топы, штаны,
   шорты, остальное (сумки…) — в конце. Меню приходит из навигации Shopify в любом
   порядке — переставляем сами, во всех местах (выпадающее на ПК, меню на телефоне).
   Меню скрыто до открытия, поэтому перестановка не видна. */
(function () {
  var ORDER = [/bomber/i, /down|puffer|parka/i, /sweat|hood/i, /long ?sleeve/i, /t-?shirt|\btees?\b/i, /\btops?\b/i, /pant|jean|denim|trouser/i, /short/i];
  function rank(text) {
    for (var i = 0; i < ORDER.length; i++) if (ORDER[i].test(text)) return i;
    return ORDER.length;
  }
  function sortList(ul) {
    if (ul.dataset.abcSorted) return;
    var items = Array.prototype.filter.call(ul.children, function (li) { return li.tagName === 'LI'; });
    if (items.length < 2) return;
    /* только текст самой ссылки пункта — у «MEN» внутри ещё весь его подсписок */
    var own = function (li) { var a = li.querySelector('a, summary'); return (a ? a.textContent : li.textContent).replace(/\s+/g, ' '); };
    var ranked = items.map(function (li, i) { return { li: li, r: rank(own(li)), i: i }; });
    /* меняем только списки категорий: хотя бы 2 пункта узнаём */
    if (ranked.filter(function (x) { return x.r < ORDER.length; }).length < 2) return;
    ul.dataset.abcSorted = '1';
    ranked.sort(function (a, b) { return a.r - b.r || a.i - b.i; })
      .forEach(function (x) { ul.appendChild(x.li); });
  }
  function run() {
    document.querySelectorAll('[id*="header_section"] ul, #Details-menu-drawer-container ul, .menu-drawer ul').forEach(sortList);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  addEventListener('load', run);
})();

/* ABC 26.09 (43): шапка ПК на сенсорных экранах (планшет, «версия для ПК» на телефоне; тема —
   assets/utilities.js setHeaderMenuStyle). Наведения пальцем нет, поэтому для касаний:
   первый тап по MEN / WOMEN — открыть список категорий, второй — перейти в раздел,
   тап мимо меню — закрыть. «Палец ушёл» (pointerleave от касания) теме не отдаём —
   иначе список закрывался сразу после тапа. Мышь работает как раньше. */
(function () {
  if (!('ontouchstart' in window) && !(navigator.maxTouchPoints > 0)) return;
  var lastTouch = 0, armed = null;
  document.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') lastTouch = Date.now(); }, true);
  function isTouchTap() { return Date.now() - lastTouch < 800; }
  function desktopMenu() { var h = document.getElementById('header-component'); return h && h.dataset.menuStyle === 'menu'; }
  /* на window (фаза захвата) — раньше обработчиков темы, которые висят на document */
  ['pointerleave', 'pointerout'].forEach(function (t) {
    window.addEventListener(t, function (e) {
      if (e.pointerType === 'touch' && e.target.closest && e.target.closest('header-menu')) e.stopImmediatePropagation();
    }, true);
  });
  function closeMenu() {
    if (!armed) return;
    var li = armed; armed = null;
    li.dispatchEvent(new PointerEvent('pointerleave', { pointerType: 'mouse' }));
  }
  document.addEventListener('click', function (e) {
    if (!desktopMenu() || !isTouchTap()) return;
    var link = e.target.closest && e.target.closest('header-menu .menu-list__link');
    if (link) {
      var li = link.closest('.menu-list__list-item');
      var hasSub = li && li.querySelector('.menu-list__submenu');
      if (hasSub && armed !== li) {
        e.preventDefault();
        e.stopPropagation();
        if (armed && armed !== li) closeMenu();
        armed = li;
        /* раскрытие тема отмечает на самой ссылке (aria-expanded) */
        if (link.getAttribute('aria-expanded') !== 'true') li.dispatchEvent(new PointerEvent('pointerenter', { pointerType: 'mouse' }));
        return;
      }
      armed = null;                       /* второй тап — обычный переход по ссылке */
      return;
    }
    if (!(e.target.closest && e.target.closest('header-menu'))) closeMenu();
  }, true);
})();
